<template>
  <div class="mt-5">
    <v-row>
      <v-col></v-col>
    </v-row>

    <v-row class="mt-5 mb-4">
      <v-col
        class="col-10 col-lg-5 d-flex flex-column ml-4 mt-4 justify-center align-center"
      >
        <h1>Vamos conversar!</h1>
        <v-img
          alt="Logo"
          class="shrink mr-2"
          contain
          src="../assets/talk.png"
          transition="scale-transition"
          width="500"
        />
      </v-col>
      <v-col class="col-11 col-lg-5 mt-5 pt-5 mb-5 ml-2">
        <ContactForm />
      </v-col>
    </v-row>
    <v-row class="ml-4  mb-4">
      <v-col class="col-10 ml-4">
        <v-icon> mdi-deskphone </v-icon> Telefone para contato:
        <a href="tel:+55 (12) 99876-5432">+55 (12) 99876-5432</a>
      </v-col>
      <v-col class="col-12 ml-4 mb-4">
        <v-icon> mdi-headset </v-icon> Nossa central:
        <a href="tel:+55 (12) 99876-5432">+55 (12) 99876-5432</a>
      </v-col>
    </v-row>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: "Contact",
  components: {
    Footer,
    ContactForm
  }
};
</script>
